import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class MobileUserRatingTrackingEvent extends BasicTrackingEvent {
    public static TYPE_RATE_NOW: number = 1;
    public static TYPE_NOT_NOW: number = 2;
    public static TYPE_NEVER: number = 3;

    public playerId: number = -1;
    public trackType: number;
    public stars: number;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};
        vars.playerId = this.playerId;
        vars.var_1 = this.trackType;
        vars.var_2 = this.stars;
        return vars;
    }
}
